import { keyframes, styled } from 'styled-components';
import Input from '../../components/utils/Input/Input';
import { Elements } from '@stripe/react-stripe-js';
import { ReactComponent as XIcon } from '../../assets/icons/close.svg';
import ReactGoogleAutocomplete from 'react-google-autocomplete';

const fadeIn = keyframes`
  from {
    opacity: 0;

  }
  to {
    opacity: 1;

  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;

  }
  to {
    opacity: 0;

  }
`;

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  min-height: 100vh;
  background-color: #faf5f6;
  gap: 33px;
  padding-right: 33px;
  @media (max-width: 800px) {
    padding-top: 50px;
    padding-left: 33px;
  }
`;
export const ContentContainer = styled.div`
  padding-bottom: 100px;
  padding-left: 265px;
  width: 100%;
  @media (max-width: 800px) {
    padding-left: 0;
  }
`;
export const StyledElements = styled(Elements)`
  font-family: 'Poppins-Medium';
`;

export const CloseIcon = styled(XIcon)`
  cursor: pointer;
`;

export const ProfileContainer = styled.div`
  width: 100%;
  gap: 32px;
  flex-wrap: wrap;
  flex-direction: row;
  display: flex;
  @media (max-width: 800px) {
    justify-content: center;
  }
`;
export const Fade = styled.div`
  gap: 16px;
  animation: ${props => (props.$open ? fadeIn : fadeOut)} 0.2s ease-in-out;
  display: flex;
  flex-direction: column;
`;
export const LeftSide = styled.div`
  min-width: 412px;
  transition: all 0.2s ease-in-out;
  min-height: ${props => (props.$edit ? '936px' : '722px')};
  max-height: 1036px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.04);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  @media (max-width: 570px) {
    min-width: 100%;
  }
`;
export const RightSide = styled(LeftSide)`
  transition: all 0.2s ease-in-out;
  height: fit-content;
  min-width: 532px;
  @media (max-width: 570px) {
    min-width: 100%;
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  user-select: none;
  cursor: pointer;
  align-items: center;
  margin-top: -10px;
  gap: 8px;
  margin-left: 8px;
`;
export const Text = styled.span`
  color: #000;

  font-size: 12px;
  user-select: none;
  font-family: 'Poppins-Medium';
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.2px;

  margin-bottom: 5px;
`;
export const Title = styled.span`
  color: #000;
  font-family: Playfair Display;
  font-size: 20px;
  user-select: none;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;
export const SubTitle = styled.span`
  color: #000;
  font-family: 'Poppins-Medium';

  font-size: 16px;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.2px;
`;

export const UploadContainer = styled.div`
  transition: all 0.2s ease-in-out;
  width: 100%;
  min-height: 300px;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: rgba(220, 203, 197, 0.5);
  border: 1px solid #dccbc5;
  gap: 12px;
  padding: 12px 16px;

  &:active {
    transition: all 0.2s ease-out;
    /* opacity: ${props => (props.$selected ? '1' : '0.65')}; */
  }
`;

export const ThinText = styled.span`
  color: #474747;
  font-family: 'Poppins-Regular';

  font-size: 12px;

  user-select: none;
`;
export const Text2 = styled.span`
  color: #000;
  user-select: none;
  text-align: center;
  font-family: 'Poppins-Medium';

  font-size: 14px;
  font-style: normal;

  line-height: normal;
  letter-spacing: -0.408px;
`;
export const UnderlineText2 = styled.span`
  color: #000;
  text-align: center;

  font-size: 14px;
  font-style: normal;
  font-family: 'Poppins-Medium';

  user-select: none;
  letter-spacing: -0.408px;
  text-decoration-line: underline;
`;
export const Row2 = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  gap: 4px;
`;
export const Column2 = styled.div`
  display: flex;
  gap: 4px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const ImagesContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 12px !important;
  align-items: center;
  justify-content: center;
`;
export const AddPhotoContainer = styled.div`
  width: 80px;
  height: 80px;
  animation: ${props => (props.$open ? fadeIn : fadeOut)} 0.3s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-radius: 10px;
  background-color: #dccbc5;
  &:active {
    transition: all 0.2s ease-out;
    opacity: 0.65;
  }
`;
export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;
export const AddInputContainer = styled.div`
  flex-direction: row;
  display: flex;

  align-items: center;
  width: 100%;
  gap: 5px;
`;

export const EditContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;
export const IconsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-direction: row;
`;

export const ImageContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
`;
export const LoaderContainer = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  flex: 1;
  width: 100%;
`;
export const IconContainer = styled.div`
  position: relative;
  width: 8rem;
  height: 8rem;
`;

export const StyledInput = styled(Input)`
  min-width: 100%;
`;
export const InputLink = styled(Input)`
  min-width: 322px;
  @media (max-width: 570px) {
    min-width: 100%;
  }
`;

export const UploadInput = styled.input`
  background: red;
  width: 80px;
  position: absolute;
  height: 80px;
  border-radius: 10px;
  opacity: 0;
  top: 0;
  cursor: pointer;
`;
export const UploadInputBig = styled(UploadInput)`
  height: 317px;
  width: 80px;
`;
export const UploadInputSmall = styled(UploadInput)`
  height: 54px;
  width: 380px;
  left: 0;

  @media (max-width: 570px) {
    width: 100%;
  }
`;

export const BankCard = styled.div`
  border-radius: 10px;
  background: #fff;
  display: flex;
  width: 412px;
  padding: 16px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.04);
  gap: 9px;
  @media (max-width: 570px) {
    width: 100%;
  }
`;

export const StyledColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  @media (max-width: 570px) {
    width: 100%;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const UnderLineText = styled.span`
  font-size: 15px;
  font-family: 'Poppins-Medium';

  text-decoration: underline;
  letter-spacing: -0.408px;
  user-select: none;
  cursor: pointer;
  &:hover {
    opacity: 0.7;
    transition: all 0.2s ease-in-out;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 54px;
  align-items: center;
`;
export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const StyledText = styled.span`
  font-size: 14px;

  font-family: ${props => (props.$bold ? 'Poppins-Medium' : 'Poppins-Regular')};
`;

export const MediaCard = styled.div`
  border-radius: 10px;
  background: #fff;
  display: flex;
  width: 412px;
  padding: 16px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.04);
  gap: 9px;
  min-height: 576px;
  @media (max-width: 570px) {
    width: 100%;
    min-width: fit-content;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 10px;
`;

export const StyledButton = styled.button`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  padding: 8px 16px 8px 12px;
  border-radius: 12px;
  border: ${props => (props.$black ? '1px solid black' : '1px solid #be6a59')};
  background-color: ${props => (props.$black ? 'black' : 'white')};
  cursor: pointer;
  outline: none;

  max-height: 40px;
  &:active {
    scale: 0.98;
    transition: all 0.2s ease-in-out;
  }
  &:disabled {
    background-color: #a6a6a6;
    border: #a6a6a6;
    opacity: 0.5;
  }
`;

export const ButtonText = styled.span`
  user-select: none;
  font-family: 'Poppins-Medium';
  font-size: 14px;
  letter-spacing: -0.408px;
  color: ${props => (props.$black ? 'white' : 'black')};
`;

export const AutoCompleteInput = styled(ReactGoogleAutocomplete)`
  width: 100%;
  align-items: center;
  gap: 10px;
  padding: ${props => (props.$icon ? '12px 12px 12px 48px' : '12px 12px 12px 12px')};
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: none;
  border-bottom: 1px solid #e2dddb;
  &:focus {
    outline: none;
    border-bottom: 1px solid #000;
  }
  &::placeholder {
    color: ${props => (props.$noOpacity ? '#000' : '')};
    opacity: ${props => (props.$noOpacity ? 1 : 0.5)};
  }

  font-size: 16px;
  font-style: normal;
  font-family: 'Poppins-Medium';

  line-height: normal;
  letter-spacing: -0.2px;
  background-color: transparent;
`;

export const TextDescAddress = styled.span`
  font-family: 'Poppins-Medium';
  font-size: 10px;
  letter-spacing: -0.408px;
  opacity: 0.5;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 3px;
`;
